import { useState } from "react";
import { Link } from "wouter";
import { ActiveModelProvider } from "../active-model-context";
import { ModelPicker } from "../model-picker";
import { PromptsEditor } from "./prompts-editor";
import { SignalMatrix } from "./signal-matrix";

type Tab = "signals" | "prompts";

export default function LevelAssessmentConfig() {
  return (
    <ActiveModelProvider>
      <LevelAssessmentConfigInner />
    </ActiveModelProvider>
  );
}

function LevelAssessmentConfigInner() {
  const [tab, setTab] = useState<Tab>("signals");

  return (
    <div className="ci-stripe ci-stripe-page">
      <div className="ci-narrow fade-up" style={{ width: "100%", maxWidth: 1100 }}>
        {/* Header */}
        <div style={{ marginBottom: 24 }}>
          <Link
            href="/labs/level-assessment"
            style={{
              fontSize: 12,
              color: "var(--r-ink-muted)",
              textDecoration: "none",
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              fontWeight: 600,
            }}
          >
            ← Voltar para avaliação
          </Link>
          <h1
            style={{
              margin: "8px 0 6px",
              fontSize: 28,
              fontWeight: 600,
              color: "var(--r-ink)",
              letterSpacing: "-0.01em",
            }}
          >
            Configuração da avaliação
          </h1>
          <p
            style={{
              margin: 0,
              fontSize: 14,
              color: "var(--r-ink-muted)",
              lineHeight: 1.55,
              maxWidth: 760,
            }}
          >
            O nível final vem de 4 chamadas de eixo, agregadas por média + dispersão. Aqui você vê
            quais sinais alimentam cada eixo (com força variável — um sinal pode entrar em vários
            eixos) e edita o prompt de cada eixo.
          </p>
        </div>

        {/* Model picker — scopes the matrix + prompts below. */}
        <ModelPicker />

        {/* Tab strip */}
        <div
          role="tablist"
          aria-label="Seção"
          style={{
            display: "flex",
            gap: 4,
            borderBottom: "1px solid var(--r-ink-faint, #e9e3d8)",
            marginBottom: 24,
          }}
        >
          {(
            [
              { id: "signals", label: "Sinais por eixo" },
              { id: "prompts", label: "Prompts" },
            ] as const
          ).map((t) => {
            const isActive = t.id === tab;
            return (
              <button
                key={t.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setTab(t.id)}
                data-testid={`config-tab-${t.id}`}
                style={{
                  background: "transparent",
                  border: "none",
                  padding: "10px 14px",
                  fontSize: 14,
                  fontWeight: isActive ? 600 : 500,
                  color: isActive ? "var(--r-ink)" : "var(--r-ink-muted)",
                  borderBottom: isActive ? "2px solid var(--r-ink)" : "2px solid transparent",
                  cursor: "pointer",
                  marginBottom: -1,
                }}
              >
                {t.label}
              </button>
            );
          })}
        </div>

        {tab === "signals" ? <SignalMatrix /> : <PromptsEditor />}
      </div>
    </div>
  );
}
